export default "__VITE_ASSET__Dvn1XiKd__"